var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "96px",
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Avatar/Homme") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 48,
    cy: 48,
    r: 48
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avatar/Homme",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7599817,52 L31.7599817,63.8754728 L26,66.3744822 C26,66.3744822 29.8402922,77 40.7209681,77 C51.6007306,77 58,66.3744822 58,66.3744822 L52.2409315,63.8754728 L52.2409315,53.249955 L31.7599817,52 Z",
    id: "Fill-1",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8248291,60.1734636 C31.8248291,60.1734636 42.1973178,68 46.5712897,68 C50.9434788,68 54.1689453,64.786499 54.1689453,64.786499 L52.2409315,63.8754728 L52.2409315,53 L31.8248291,55.6094719 L31.8248291,60.1734636 Z",
    id: "Fill-3",
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.1105957,64.5 C52.6137728,72.2423313 47.2916846,73.2905745 42.0003519,73.2905745 C36.7080687,73.2905745 32.3644456,71.4682097 28.1271973,64.5 C28.1271973,64.5 4.5874833,74.8388176 2.00692494,78.7094255 C-0.573633416,82.5811489 0.0717437949,88 0.0717437949,88 L42.0003519,88 L83.9280095,88 C83.9280095,88 84.5743372,82.5811489 81.9937788,78.7094255 C79.4132204,74.8388176 56.1105957,64.5 56.1105957,64.5 Z",
    id: "Fill-5",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8993475,30.2810517 C65.2332273,27.1350861 60.855735,28.0788758 60.855735,28.0788758 L61.5732363,19.2692656 L57.5811028,11.7189483 L42.0566486,7.03354488 L42.0566486,7 L41.9997623,7.01722575 L41.9437935,7 L41.9437935,7.03354488 L26.4184218,11.7189483 L22.4262882,19.2692656 L22.9189969,28.0788758 C22.9189969,28.0788758 18.7653797,27.1350861 18.100177,30.2810517 C17.4358918,33.4270172 20.09762,42.2366274 25.4210765,41.6074343 C25.4210765,41.6074343 24.7549563,48.5276519 28.7470899,52.3046238 C32.7080278,56.0480508 37.3231581,62.8848595 41.9437935,62.9954669 L41.9437935,63 C41.9621439,63 41.9814118,62.9972801 41.9997623,62.9972801 C42.0181127,62.9972801 42.0373806,63 42.0566486,63 L42.0566486,62.9954669 C46.6763665,62.8848595 51.2914968,56.0480508 55.2524346,52.3046238 C59.2445682,48.5276519 58.5793655,41.6074343 58.5793655,41.6074343 C63.902822,42.2366274 66.5654677,33.4270172 65.8993475,30.2810517",
    id: "Fill-8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2799655,34.3684285 L23.5672056,34.3684285 C23.5672056,34.3684285 22.9235856,17.9475682 25.4971476,15.420372 C28.0716277,12.8940858 33.8614535,9.73622804 44.1566196,12.2625142 C54.4517857,14.7888004 58.9552896,18.5782297 58.9552896,18.5782297 L59.5989097,35 L61.5288516,33.1052854 C61.5288516,33.1052854 65.3896537,17.3150866 63.4597117,12.2625142 C61.5288516,7.20994185 48.6601236,-1.63296986 37.0786356,0.261744782 C25.4971476,2.15645943 22.2799655,5.94679876 22.9235856,11.6309427 C22.9235856,11.6309427 18.4200816,12.8940858 19.0627835,17.9475682 C19.7064036,23.0001406 22.2799655,34.3684285 22.2799655,34.3684285",
    id: "Fill-10",
    fill: "#555050"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.376ba8d0ec74df2edfce16ca5e752321.svg";
export { ForwardRef as ReactComponent };